import {
  IUsersTypes,
  IUser,
  IGroup,
  IProfile,
  ICamundaUser,
  IActivatedUsers,
  IUserProfile,
} from './types';

export function getUsersRequest(page: number, limit: number, search: string) {
  return {
    type: IUsersTypes.GET_USERS_REQUEST,
    payload: { page, limit, search },
  };
}
export function getUsersSuccess(
  users: IUser[],
  pagecount: number,
  total: number,
) {
  return {
    type: IUsersTypes.GET_USERS_SUCCESS,
    payload: { users, pagecount, total },
  };
}
export function getUsersFailure() {
  return {
    type: IUsersTypes.GET_USERS_FAILURE,
  };
}

export function getUserByApplicationIdAndEmailRequest(
  applicationId: number,
  email: string,
) {
  return {
    type: IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_REQUEST,
    payload: { applicationId, email },
  };
}

export function getUserByApplicationIdAndEmailSuccess(user: IUser) {
  return {
    type: IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_SUCCESS,
    payload: { user },
  };
}
export function getUserByApplicationIdAndEmailFailure() {
  return {
    type: IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_FAILURE,
  };
}

export function addUserRequest(data: { [key: string]: unknown }) {
  return {
    type: IUsersTypes.ADD_USER_REQUEST,
    payload: { data },
  };
}
export function addUserSuccess() {
  return {
    type: IUsersTypes.ADD_USER_SUCCESS,
  };
}
export function addUserFailure() {
  return {
    type: IUsersTypes.ADD_USER_FAILURE,
  };
}

export function changeUserPasswordRequest(
  id: number,
  managerId?: number,
  password?: string,
  newPassword?: string,
  personId?: number,
  userEmail?: string,
) {
  return {
    type: IUsersTypes.CHANGE_USER_PASSWORD_REQUEST,
    payload: { id, managerId, password, newPassword, personId, userEmail },
  };
}
export function changeUserPasswordSuccess() {
  return {
    type: IUsersTypes.CHANGE_USER_PASSWORD_SUCCESS,
  };
}
export function changeUserPasswordFailure() {
  return {
    type: IUsersTypes.CHANGE_USER_PASSWORD_FAILURE,
  };
}

export function changeUserPasswordResetRequest() {
  return {
    type: IUsersTypes.CHANGE_USER_PASSWORD_RESET_REQUEST,
  };
}

export function activateUserRequest(user_id: number, activate: boolean) {
  return {
    type: IUsersTypes.ACTIVATE_USER_REQUEST,
    payload: { user_id, activate },
  };
}
export function activateUserSuccess(user_id: number, activate: boolean) {
  return {
    type: IUsersTypes.ACTIVATE_USER_SUCCESS,
    payload: { user_id, activate },
  };
}
export function activateUserFailure() {
  return {
    type: IUsersTypes.ACTIVATE_USER_FAILURE,
  };
}

export function getGroupsRequest() {
  return {
    type: IUsersTypes.GET_GROUPS_REQUEST,
  };
}
export function getGroupsSuccess(groups: IGroup[]) {
  return {
    type: IUsersTypes.GET_GROUPS_SUCCESS,
    payload: { groups },
  };
}
export function getGroupsFailure() {
  return {
    type: IUsersTypes.GET_GROUPS_FAILURE,
  };
}

export function getUserGroupsRequest(user_id: number) {
  return {
    type: IUsersTypes.GET_USER_GROUPS_REQUEST,
    payload: { user_id },
  };
}
export function getUserGroupsSuccess(user_id: number, groups: IGroup[]) {
  return {
    type: IUsersTypes.GET_USER_GROUPS_SUCCESS,
    payload: { user_id, groups },
  };
}
export function getUserGroupsFailure() {
  return {
    type: IUsersTypes.GET_USER_GROUPS_FAILURE,
  };
}

export function addUserGroupRequest(user_id: number, group: IGroup) {
  return {
    type: IUsersTypes.ADD_USER_GROUP_REQUEST,
    payload: { user_id, group },
  };
}
export function addUserGroupSuccess(user_id: number, group: IGroup) {
  return {
    type: IUsersTypes.ADD_USER_GROUP_SUCCESS,
    payload: { user_id, group },
  };
}
export function addUserGroupFailure() {
  return {
    type: IUsersTypes.ADD_USER_GROUP_FAILURE,
  };
}

export function removeUserGroupRequest(user_id: number, group: IGroup) {
  return {
    type: IUsersTypes.REMOVE_USER_GROUP_REQUEST,
    payload: { user_id, group },
  };
}
export function removeUserGroupSuccess(user_id: number, group: IGroup) {
  return {
    type: IUsersTypes.REMOVE_USER_GROUP_SUCCESS,
    payload: { user_id, group },
  };
}
export function removeUserGroupFailure() {
  return {
    type: IUsersTypes.REMOVE_USER_GROUP_FAILURE,
  };
}

export function getProfilesRequest() {
  return {
    type: IUsersTypes.GET_PROFILES_REQUEST,
  };
}
export function getProfilesSuccess(profiles: IProfile[]) {
  return {
    type: IUsersTypes.GET_PROFILES_SUCCESS,
    payload: { profiles },
  };
}
export function getProfilesFailure() {
  return {
    type: IUsersTypes.GET_PROFILES_FAILURE,
  };
}

export function getUserProfileRequest(personId: number) {
  return {
    type: IUsersTypes.GET_USER_PROFILE_REQUEST,
    payload: { personId },
  };
}

export function getUserProfileSuccess(userProfile: IUserProfile) {
  return {
    type: IUsersTypes.GET_USER_PROFILE_SUCCESS,
    payload: { userProfile },
  };
}

export function getUserProfileFailure() {
  return {
    type: IUsersTypes.GET_USER_PROFILE_FAILURE,
  };
}

export function getUserProfilesRequest(user_id: number) {
  return {
    type: IUsersTypes.GET_USER_PROFILES_REQUEST,
    payload: { user_id },
  };
}
export function getUserProfilesSuccess(user_id: number, profiles: IProfile[]) {
  return {
    type: IUsersTypes.GET_USER_PROFILES_SUCCESS,
    payload: { user_id, profiles },
  };
}
export function getUserProfilesFailure() {
  return {
    type: IUsersTypes.GET_USER_PROFILES_FAILURE,
  };
}

export function addUserProfileRequest(user_id: number, profile: IProfile) {
  return {
    type: IUsersTypes.ADD_USER_PROFILE_REQUEST,
    payload: { user_id, profile },
  };
}
export function addUserProfileSuccess(user_id: number, profile: IProfile) {
  return {
    type: IUsersTypes.ADD_USER_PROFILE_SUCCESS,
    payload: { user_id, profile },
  };
}
export function addUserProfileFailure() {
  return {
    type: IUsersTypes.ADD_USER_PROFILE_FAILURE,
  };
}

export function updateUserProfileRequest(
  personId: number,
  userProfile: IUserProfile,
) {
  return {
    type: IUsersTypes.UPDATE_USER_PROFILE_REQUEST,
    payload: { personId, userProfile },
  };
}
export function updateUserProfileSuccess(userProfile: IUserProfile) {
  return {
    type: IUsersTypes.UPDATE_USER_PROFILE_SUCCESS,
    payload: { userProfile },
  };
}
export function updateUserProfileFailure() {
  return {
    type: IUsersTypes.UPDATE_USER_PROFILE_FAILURE,
  };
}

export function removeUserProfileRequest(user_id: number, profile: IProfile) {
  return {
    type: IUsersTypes.REMOVE_USER_PROFILE_REQUEST,
    payload: { user_id, profile },
  };
}
export function removeUserProfileSuccess(user_id: number, profile: IProfile) {
  return {
    type: IUsersTypes.REMOVE_USER_PROFILE_SUCCESS,
    payload: { user_id, profile },
  };
}
export function removeUserProfileFailure() {
  return {
    type: IUsersTypes.REMOVE_USER_PROFILE_FAILURE,
  };
}

export function getCamundaUsersRequest() {
  return {
    type: IUsersTypes.GET_CAMUNDA_USERS_REQUEST,
  };
}
export function getCamundaUsersSuccess(camundaUsers: ICamundaUser[]) {
  return {
    type: IUsersTypes.GET_CAMUNDA_USERS_SUCCESS,
    payload: { camundaUsers },
  };
}
export function getCamundaUsersFailure() {
  return {
    type: IUsersTypes.GET_CAMUNDA_USERS_FAILURE,
  };
}

export function getActivatedUsersRequest(profileKey?: string) {
  return {
    type: IUsersTypes.GET_ACTIVATED_USERS_REQUEST,
    payload: { profileKey },
  };
}
export function getActivatedUsersSuccess(activatedUsers: IActivatedUsers) {
  return {
    type: IUsersTypes.GET_ACTIVATED_USERS_SUCCESS,
    payload: { activatedUsers },
  };
}
export function getActivatedUsersFailure() {
  return {
    type: IUsersTypes.GET_ACTIVATED_USERS_FAILURE,
  };
}

export function getUsersByGroupsRequest(groups: IGroup[]) {
  return {
    type: IUsersTypes.GET_USERS_BY_GROUPS_REQUEST,
    payload: { groups },
  };
}
export function getUsersByGroupsSuccess(usersByGroups: any) {
  return {
    type: IUsersTypes.GET_USERS_BY_GROUPS_SUCCESS,
    payload: { usersByGroups },
  };
}
export function getUsersByGroupsFailure() {
  return {
    type: IUsersTypes.GET_USERS_BY_GROUPS_FAILURE,
  };
}
